import Typography from '@mui/material/Typography'
import { styled, CSSObject } from '@mui/material/styles'
import { VoucherBannerVariant } from '../../VoucherBanner.types'

const GRADIENTS: Record<VoucherBannerVariant, string> = {
  smava: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  ffg: 'linear-gradient(270deg, #0D315B 0%, #165297 100%)'
}

export const BannerContainer = styled('div')<{ variant: VoucherBannerVariant }>(
  ({ theme, variant }) => ({
    background: GRADIENTS[variant],
    color: '#fff',
    overflow: 'hidden',
    padding: theme.spacing(0, 1.5)
  })
)

export const MaxWidthWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))

export const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column'
})

export const Illustration = styled('img')<{
  variant: VoucherBannerVariant
  isCollapsed: boolean
}>(({ variant, isCollapsed }) => {
  const baseStyle: CSSObject = {
    position: 'absolute',
    right: -10,
    bottom: 0,
    top: -5,
    height: 102,
    width: 'auto',
    pointerEvents: 'none',
    transition: 'bottom 0.3s ease'
  }
  if (variant === 'ffg') {
    return {
      ...baseStyle,
      height: 'auto',
      width: 152,
      top: 'unset',
      bottom: isCollapsed ? -40 : -8,
      opacity: 0.2
    }
  }
  return baseStyle
})

export const HeaderRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 48,
  zIndex: 1,
  position: 'relative'
})

export const TitleRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1
})

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'bannerVariant'
})<{ bannerVariant: VoucherBannerVariant }>(({ bannerVariant }) => ({
  fontWeight: 700,
  fontSize: '15px',
  color: '#fff',
  lineHeight: 1.3,
  ...(bannerVariant === 'ffg' && { fontFamily: "'Lato', sans-serif" })
}))

export const BodyText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'bannerVariant'
})<{ bannerVariant: VoucherBannerVariant }>(({ theme, bannerVariant }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: '#fff',
  lineHeight: 1.4,
  paddingBottom: theme.spacing(1.5),
  position: 'relative',
  zIndex: 1,
  ...(bannerVariant === 'ffg' && { fontFamily: "'Lato', sans-serif" })
}))

export const UnderlinedLink = styled('a')({
  textDecoration: 'underline',
  cursor: 'pointer',
  color: '#fff'
})
